<template>
  <div v-if="open" class="overlay" @click.self="$emit('close')">
    <div class="modal">
      <div class="modal-head">
        <div>
          <div class="eyebrow">{{ eyebrow }}</div>
          <h3>{{ heading }}</h3>
        </div>
        <button class="close-btn" @click="$emit('close')">×</button>
      </div>

      <p v-if="description" class="description">{{ description }}</p>

      <form class="form" @submit.prevent="submit">
        <label class="field">
          <span>Nombre</span>
          <input v-model.trim="form.title" type="text" maxlength="150" :placeholder="placeholder" required>
        </label>

        <label v-if="showScopeSelector" class="field">
          <span>Ubicación</span>
          <div class="scope-switch">
            <button type="button" :class="{ active: form.scopeType === 'personal' }" @click="form.scopeType = 'personal'; form.groupId = ''">Personal</button>
            <button type="button" :class="{ active: form.scopeType === 'group' }" @click="form.scopeType = 'group'">Grupal</button>
          </div>
        </label>

        <label v-if="form.scopeType === 'group'" class="field">
          <span>Grupo</span>
          <select v-model="form.groupId" required>
            <option value="" disabled>Selecciona un grupo</option>
            <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
          </select>
        </label>

        <div class="actions">
          <button type="button" class="ghost-btn" @click="$emit('close')">Cancelar</button>
          <button class="dark-btn">{{ submitLabel }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateListModal',
  props: {
    open: { type: Boolean, default: false },
    groups: { type: Array, default: () => [] },
    presetGroupId: { type: String, default: '' },
    heading: { type: String, default: 'Crear nota' },
    eyebrow: { type: String, default: 'Nueva hoja' },
    description: { type: String, default: '' },
    placeholder: { type: String, default: 'Ej. Compras de la semana' },
    submitLabel: { type: String, default: 'Crear hoja' },
  },
  emits: ['close', 'submit'],
  data() {
    return {
      form: {
        title: '',
        scopeType: 'personal',
        groupId: '',
      },
    };
  },
  computed: {
    showScopeSelector() {
      return this.groups.length > 0 && !this.presetGroupId;
    },
  },
  watch: {
    open: {
      immediate: true,
      handler(value) {
        if (!value) return;
        this.form = {
          title: '',
          scopeType: this.presetGroupId ? 'group' : 'personal',
          groupId: this.presetGroupId || '',
        };
      },
    },
    presetGroupId(value) {
      if (value) {
        this.form.scopeType = 'group';
        this.form.groupId = value;
      }
    },
  },
  methods: {
    submit() {
      if (!this.form.title) return;
      if (this.form.scopeType === 'group' && !this.form.groupId) return;
      this.$emit('submit', {
        title: this.form.title,
        groupId: this.form.scopeType === 'group' ? this.form.groupId : null,
      });
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.34);
  display: grid;
  place-items: center;
  padding: 24px;
  z-index: 60;
}
.modal {
  width: min(520px, 100%);
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 24px;
  padding: 22px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.18);
}
.modal-head {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.eyebrow {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: .12em;
  color: #64748b;
}
.description {
  margin: 12px 0 0;
  color: #475569;
  line-height: 1.5;
}
h3 {
  margin: 6px 0 0;
  font-size: 28px;
  color: #0f172a;
}
.close-btn {
  border: none;
  background: transparent;
  font-size: 34px;
  color: #64748b;
  cursor: pointer;
}
.form {
  display: grid;
  gap: 16px;
  margin-top: 18px;
}
.field {
  display: grid;
  gap: 8px;
}
.field span {
  font-size: 13px;
  font-weight: 700;
  color: #334155;
}
input,
select {
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.24);
  background: rgba(248,250,252,0.92);
  padding: 14px 16px;
  font-size: 16px;
  outline: none;
}
.scope-switch {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}
.scope-switch button,
.ghost-btn,
.dark-btn {
  border: none;
  border-radius: 14px;
  padding: 12px 14px;
  font-weight: 800;
  cursor: pointer;
}
.scope-switch button {
  background: rgba(59,130,246,.1);
  color: #1d4ed8;
}
.scope-switch button.active,
.dark-btn {
  background: #111827;
  color: white;
}
.ghost-btn {
  background: rgba(241,245,249,.92);
  color: #334155;
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
